import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TacticalLiaison } from '../../shared/services/tactical-liaison.service';
import { ViewableRequest } from '../review-request/review-request.model';
import { Sources } from '../../shared/services/request-comments.service';

@Component({
  selector: 'app-request-assignment-modal',
  templateUrl: './request-assignment-modal.component.html',
  styleUrls: ['./request-assignment-modal.component.css']
})
export class RequestAssignmentModalComponent implements OnInit {

  public request: ViewableRequest;
  public tacticalLiaisons : TacticalLiaison[] = [];
  public assignmentForm: FormGroup;

  public onClose: Subject<any> = new Subject<any>();
  public onAssigned: Subject<AssignmentWithComments> = new Subject<AssignmentWithComments>();

  constructor(private modalRef: BsModalRef, formBuilder: FormBuilder) { 
    this.assignmentForm = formBuilder.group({
      tacticalLiaison: formBuilder.control(null, [Validators.required]),
      comment: formBuilder.control(null)
    });
  }

  ngOnInit() {
  }

  public closeModal(): void {
    this.modalRef.hide();
  }

  public assignRequest(): void {
    var formData = this.assignmentForm.value as AssignmentFormModel;

    this.onAssigned.next({
      id: this.request.id,
      tacticalLiaisonId: formData.tacticalLiaison,
      comment: formData.comment,
      source: Sources.submittedToAssigned
    });
  }
}

export interface AssignmentWithComments {
  id: number;
  tacticalLiaisonId: number;
  comment: string;
  source: string;
}

interface AssignmentFormModel {
  tacticalLiaison: number;
  comment: string;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-assignment-modal/request-assignment-modal.component.ts